<template>
    <div class="text-muted content-center text-center" v-if="loading">
        <Spinner size="2x" />
    </div>
    <table class="table" :class="classes" v-else>
        <thead v-if="$slots.thead && $slots.default">
            <slot name="thead"></slot>
        </thead>
        <tbody>
            <slot name="default" v-if="$slots.default"></slot>
            <tr class="table-warning" v-else>
                <td>{{ $t('table.empty') }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
    import Spinner from '../Loaders/Spinner'

    export default {
        props: {
            loading: Boolean,
            striped: Boolean,
            borderless: Boolean,
            curved: {
                type: Boolean,
                default: true
            },
            hover: Boolean,
            responsive: Boolean
        },
        computed: {
            classes: function() {
                return [
                    { 'table-striped': this.striped },
                    { 'table-borderless': this.borderless },
                    { 'table-curved rounded': this.curved },
                    { 'table-hover': this.hover },
                    { 'table-responsive': this.responsive }
                ];
            }
        },
        components: {
            Spinner
        }
    }
</script>